import React from 'react';
import ValidatingInput from '../ValidatingInput/ValidatingInput';
import useCurrentUser from '../../services/User/UserHooks';

export default function OwnerSelector(props) {
    const user = useCurrentUser();
    let valueObject = null;
    let groupsOptions = [];

    if (user && Array.isArray(user.groups) && user.groups.length > 0) {
        groupsOptions = user.groups.map(grp => {
            return { label: grp.Name, value: grp.Id };
        });
        const owners = props.dataSet[props.dataKey];
        if (groupsOptions && owners) {
            valueObject = groupsOptions.filter(gobj => owners.some(owner => owner === gobj.value));
        }
    }

    if(valueObject === null) return null;
    
    return (
        <ValidatingInput
            label={props.label}
            dataSet={props.dataSet}
            dataKey={props.dataKey}
            valueObject={valueObject}
            onChange={props.onChange}
            options={groupsOptions}
            validationFn={val => {
                if (Array.isArray(val)) {
                    return groupsOptions.findIndex(go => val.some(v => v.value === go.value)) > -1;
                }
                return groupsOptions.findIndex(go => go.value === val.value) > -1;
            }}
            validationType="multiSelect"
        />
    );
}
